import getIconForEntityType from "../components/distinct-values/chart/entity-type-icons";
import { Entity } from "../types/entity";

/**
 * Utility for transforming entity data
 */

interface EntityWithoutIcon {
  id: string;
  name: string;
  count: number;
  selected: boolean;
}

/**
 * Adds appropriate icon to entity object for display based on entity name.
 * Uses the shared getIconForEntityType function to ensure consistent icons across the application.
 */
export const addIconToEntity = (entity: EntityWithoutIcon): Entity => ({
  ...entity,
  icon: getIconForEntityType(entity.name),
});

/**
 * Adds appropriate icons to array of entities
 */
export const addIconsToEntities = (entities: EntityWithoutIcon[]): Entity[] =>
  entities.map(addIconToEntity);
